import React, { Component, Fragment } from 'react'
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';
import ToolbarSimple from '../../../../Utils/Toolbar/ToolbarSimple';

import Grid from '../../../../Utils/Grid/index';
import Modal from 'react-responsive-modal';
import LoadMask from "Utils/LoadMask/LoadMask";
import {standardActions} from "../../../../Utils/Grid/StandardActions";
import { iconos } from '../../../../../../utility/icons';
import ReajusteForm from '../reajusteForm';
import { RenderNumber, RenderNumberColor } from '../../../../Utils/renderField/renderReadField';
import { ESTADOS_EXISTENCIA } from '../../../../../../utility/constants';


function cellStyleMinimo(cell, row) {
    if (row.total_existencias > row.producto__minimo_existencias && row.total_existencias < (row.producto__minimo_existencias + row.producto__minimo_existencias * 0.30)) {
        return {color: "#F3A631", fontSize: 16, fontWeight: "bold", marginLeft: 15}
    }
    else if (row.total_existencias <= row.producto__minimo_existencias) {
        return {color: "#cc5729ff", fontSize: 16, fontWeight: "bold", marginLeft: 15}
    }
    else {}
}

function colEstadoStyle(cell, row) {
    if (row.estado_existencias === 2) {
        return `estado-reporte-${3}`
    }
    else if (row.estado_existencias === 3) {
        return `estado-reporte-${5}`
    }
    else null
}

export default class BodegaMateriaPrimaGrid extends Component {
    state = {
        producto: null,
    }
    componentDidMount(){
        this.props.getInventarioBodegaMateriaPrima(1, this.props.idBodega)
    }

    pageChange = (page) => {
        this.props.getInventarioBodegaMateriaPrima(page, this.props.idBodega)
    }

    /* componentWillMount() {
        const { leer, page, listDS } = this.props;
        leer(this.props.match.params.id);
        this.props.getDespachosPendientes(this.props.match.params.id);
        // lectura de los despachos

    } */

    searchInventario = (search) => {
        const tab = 1;
        this.props.searchChangeTransicion(search, this.props.match.params.id, tab);
    }

    botonRealizarReajuste = (id, row) => {
        const producto = {
            id: row.producto__id,
            codigo: row.producto__codigo,
            nombre: row.producto__nombre,
            total_cantidad: row.total_cantidad,
            total_existencias: row.total_existencias,
            conversion: row.producto__conversion,
            unidad_medida: row.unidad_medida_display,
            empresa: {id: row.bodega__id},
        }

        return (
            <a className="px-2" style={{cursor: "pointer", color: "#c4183c"}} onClick={
                (e)=>{
                    e.preventDefault();
                    this.setState({producto: producto});
                    this.props.setOpenModal(true);
                }
            }>
                <img
                    className="action-img"
                    title="Reajustar o baja"
                    src={iconos.baja_reajuste}
                    alt="Reajustar o baja" />
            </a>
        )
    }

    handleSubmitReajuste = (values) => {
        let valores = _.cloneDeep(values);
        valores.cantidad = Number(values.cantidad);
        valores.bodega = Number(values.bodega);
        valores.tipo_movimiento = Number(values.tipo_movimiento);
        if (valores.vehiculo)
            valores.vehiculo = valores.vehiculo.id
        this.props.reajustarInventarioTransicion(valores, this.props.idBodega);
    }

    handleSelectExistencias = (value) => {
        this.props.setExistenciasFilter(value, this.props.idBodega);
    };

    handleCheckedVendible = (value) => {
        this.props.setVendibleFilter(value, this.props.idBodega);
    };

    handleCheckedFacturado = (value) => {
        this.props.setFacturadoFilter(value, this.props.idBodega);
    };

    handleCheckedRepuesto = (value) => {
        this.props.setRepuestoFilter(value, this.props.idBodega);
    };

    handleCheckedFilter = (value) => {
        this.props.setClaseProductoFilter(value, this.props.idBodega);
    };

    render() {
        const { idBodega, inventario_materia_prima, loader, listar: onPageChange, onSortChange, page_materia_prima, open_modal,
            setExistenciasFilter, vendible_filter, facturado_filter, repuesto_filter, clase_producto_filter
        } = this.props;

        return (
            <Fragment>

                <Modal open={open_modal}
                    classNames={{ modal: 'modal-xl', }}
                    onClose={(e) => {
                        this.props.setOpenModal(false);
                    }} center>
                    <div className="">
                        <h2 className="text-center text-primary text-uppercase">SELECCIONAR TIPO ACCIÓN</h2>
                    </div>
                    <ReajusteForm
                        producto={this.state.producto}
                        mostrarOpcionTrasladoMP={true}
                        initialValues={{
                            producto: this.state.producto ? this.state.producto.id : 0,
                            bodega: idBodega,
                            bodegaOrigen: 10, // Bodega de Materia Prima
                            cantidad: this.state.producto ? this.state.producto.total_cantidad || this.state.producto.cantidad : 0,
                            volumen: this.state.producto ? this.state.producto.total_existencias || this.state.producto.cantidad : 0,
                            tipo_movimiento: "50"
                        }}
                        onSubmit={this.handleSubmitReajuste}
                        cerrarModal={() => {this.props.setOpenModal(false);}}
                    />
                </Modal>

                <div className="row col-md-12 m-0 p-0 d-flex justify-content-start">

                    {/* CLASE PRODUCTO */}
                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion1"
                                autoComplete="off"
                                checked={clase_producto_filter === 0}
                                onChange={() => this.handleCheckedFilter(0)}
                            />
                            <label className="ml-1" htmlFor="opcion1"> Todo</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion2"
                                autoComplete="off"
                                checked={clase_producto_filter === 10}
                                onChange={() => this.handleCheckedFilter(10)}
                            />
                            <label className="ml-1" htmlFor="opcion2">Materia Prima</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion3"
                                autoComplete="off"
                                checked={clase_producto_filter === 20}
                                onChange={() => this.handleCheckedFilter(20)}
                            />
                            <label className="ml-1" htmlFor="opcion3">Producto Terminado</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesClase"
                                id="opcion4"
                                autoComplete="off"
                                checked={clase_producto_filter === 30}
                                onChange={() => this.handleCheckedFilter(30)}
                            />
                            <label className="ml-1" htmlFor="opcion4">Repuesto</label>
                        </div>
                    </div>

                    {/* VENDIBLE FILTER */}
                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible1111"
                                id="opcion1111"
                                autoComplete="off"
                                checked={vendible_filter === 0}
                                onChange={() => this.handleCheckedVendible(0)}
                            />
                            <label className="ml-1" htmlFor="opcion1111">Vendible / No Vendible</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible2222"
                                id="opcion2222"
                                autoComplete="off"
                                checked={vendible_filter === 1}
                                onChange={() => this.handleCheckedVendible(1)}
                            />
                            <label className="ml-1" htmlFor="opcion2222">No Vendible</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesVendible3333"
                                id="opcion3333"
                                autoComplete="off"
                                checked={vendible_filter === 2}
                                onChange={() => this.handleCheckedVendible(2)}
                            />
                            <label className="ml-1" htmlFor="opcion3333">Vendible</label>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-3 col-12">
                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado11111"
                                id="opcion11111"
                                autoComplete="off"
                                checked={facturado_filter === 0}
                                onChange={() => this.handleCheckedFacturado(0)}
                            />
                            <label className="ml-1" htmlFor="opcion11111">Facturado / No Facturado</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado22222"
                                id="opcion22222"
                                autoComplete="off"
                                checked={facturado_filter === 1}
                                onChange={() => this.handleCheckedFacturado(1)}
                            />
                            <label className="ml-1" htmlFor="opcion22222">No Facturado</label>
                        </div>

                        <div className="">
                            <input
                                type="radio"
                                className="btn-check"
                                name="opcionesFacturado33333"
                                id="opcion33333"
                                autoComplete="off"
                                checked={facturado_filter === 2}
                                onChange={() => this.handleCheckedFacturado(2)}
                            />
                            <label className="ml-1" htmlFor="opcion33333">Facturado</label>
                        </div>
                    </div>

                    <div className={"col-lg-3 col-md-6 col-12 align-self-start"}>
                        <span className="t-azul-claro font-weight-bold">Existencias</span>
                        <Select
                            isClearable={false}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={ESTADOS_EXISTENCIA}
                            placeholder={"Movimiento"}
                            defaultValue={ESTADOS_EXISTENCIA[0]}
                            onChange={(e) => {
                                this.handleSelectExistencias(e.value)
                            }}
                        />
                    </div>
                </div>

                <ToolbarSimple
                    textBoton={this.props.permisos.crear_editar_bodegas ? "Trasladar" : undefined}
                    margen={"0"}
                    ruta={`/bodega/${this.props.match.params.id}/traslado-inventario`}
                    buscar={this.searchInventario}
                    buscador={this.props.search}
                    placeholder={"Buscar por: Nombre, Código"}
                    downloadButton={{
                        label: 'DESCARGAR',
                        handleDownload: this.props.permisos.crear_editar_bodegas ? this.props.descargaArchivoInventarioBodegaEP : undefined
                    }}
                    bodega_transicion={10}
                    permisos={true}
                />
                <br />
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <Grid
                        data={inventario_materia_prima}
                        onPageChange={this.pageChange}
                        page={page_materia_prima}
                        hover
                        striped
                        loading={loader}
                        onSortChange={onSortChange}>
                        <TableHeaderColumn
                            dataField="producto__id"
                            dataAlign="center"
                            dataSort
                            isKey
                            width="5%"
                            dataFormat={
                                standardActions({ adicional: this.props.permisos.crear_editar_bodegas ? (id, row) => this.botonRealizarReajuste(id, row) : undefined})
                            }
                        >
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__codigo"
                            dataSort
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="total_cantidad"
                            dataSort
                            width="3%"
                            dataFormat = {(cell, row)=> <span className={colEstadoStyle(cell, row)} style={{margin:"0"}}></span>}
                        >
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__nombre"
                            dataSort
                        >
                            NOMBRE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="unidad_medida_display"
                            dataSort
                            dataFormat = {(cell, row) => cell.toUpperCase()}
                        >
                            UNIDAD MEDIDA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="producto__minimo_existencias"
                            dataSort
                            dataFormat = {(cell, row) => (
                                <div>
                                    <RenderNumber value={cell} decimalScale={null} /> {row.unidad_medida_display.toUpperCase()}
                                </div>
                            )}
                        >
                            MÍNIMO
                        </TableHeaderColumn>
                        {/* <TableHeaderColumn
                            dataField="producto__conversion"
                            dataSort
                            // dataAlign="center"
                            dataFormat = {(cell, row)=> <RenderNumber value={ cell} decimalScale={4} />}
                        >
                            UNIDAD CONVERSIÓN
                        </TableHeaderColumn> */}
                        <TableHeaderColumn
                            dataField="total_cantidad"
                            dataSort
                            // tdStyle={cellStyleMinimo}
                            dataFormat = {(cell, row)=> <RenderNumber value={ cell } decimalScale={ 4 } />}
                        >
                            CANTIDAD
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="total_existencias"
                            dataSort
                            // tdStyle={cellStyleMinimo}
                            dataFormat = {(cell, row) => (
                                <div>
                                    <RenderNumber value={cell} decimalScale={4} /> {row.unidad_medida_display.toUpperCase()}
                                </div>
                            )}
                        >
                            EXISTENCIAS
                        </TableHeaderColumn>
                    </Grid>
                </LoadMask>
            </Fragment>

        );
    }
}
